import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://studiocrochet.com';
const SITE_NAME = 'Studio Crochet';
const DEFAULT_IMAGE = process.env.REACT_APP_DEFAULT_OG_IMAGE || 'https://customer-assets.emergentagent.com/job_regal-collection-2/artifacts/87220c1a_Screenshot_2026-04-07_at_00.16.22-removebg-preview%20%281%29.png';

const SEO = ({
  title,
  description,
  canonical,
  image,
  type = 'website',
  schema,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Premium Ethnic Wear`;
  const metaDescription = description || 'Shop premium ethnic wear at Studio Crochet by Ekta Singh. Sarees, Lehengas, Pakistani Suits, Indo-Western outfits. COD available. Free shipping.';
  const metaImage = image || DEFAULT_IMAGE;
  const canonicalUrl = canonical || SITE_URL;

  // Handle schema as single object or array
  const schemas = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {schemas.map((s, i) => (
        <script key={`schema-${i}`} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export { SEO, SITE_URL, SITE_NAME };
export default SEO;
